import { FTL_WEB_APP_API } from 'app/commons/constants/env.const'
import { SERVICE_TYPE } from 'app/commons/constants/liveTracking.const'
import { IDynamicTextOption, ILclSettingOption } from 'app/interface/ISetting'

import api from '../commons/helpers/api/index'

const settingApi = {
  getServiceAreaByCountry: (countryCode: string, languageCode: string) =>
    api.get(
      `${FTL_WEB_APP_API}/cargo_api/v1/service_areas/by_country`,
      {
        country_code: countryCode,
      },
      {
        headers: {
          'Accept-Language': languageCode,
        },
      }
    ),
  getInfoSetting: async (currentLanguage: any) =>
    await Promise.all([
      api.get(`/v1/setting/package-units?culture=${currentLanguage}`),
      api.get(`/v1/setting/commodities?culture=${currentLanguage}`),
      api.get(`/v1/setting/ports?culture=${currentLanguage}`),
    ]),
  getSetting: (params: ILclSettingOption[]) => {
    const query = params.map((x) => `keys=${x}`)
    return api.get(`/v1/setting/settings?${query.join('&')}`)
  },
  getConfigSetting: (queryParam: { company_id?: string; area_id?: string }) =>
    api.get(`${FTL_WEB_APP_API}/api/v3/settings/customers`, queryParam),
  getAddressesInfo: (url: string, countryName = '') => api.get(`${url}?culture=${countryName || ''}`),
  getAdditionalServices: (language: string) => api.get(`/configuration/additional-services?culture=${language}`),
  getServiceTypes: () => api.get(`/v1/setting/service-types?culture=en-US`),
  getInsurance: () => api.get(`/v1/setting/goods/insurances`),
  getInsurancePolicy: () => api.get(`/v1/setting/goods/insurance/policy`),
  getPorts: () => api.get(`/v1/setting/ports`),
  getCancelReason: (category?: string, subCategory?: string, locale?: string) =>
    api.get(`/v1/setting/cancel-reasons?category=${category}&subCategory=${subCategory}&locale=${locale}`),
  getDynamicTexts: (keysList: IDynamicTextOption[]) => {
    const query = keysList.map((x) => `codes=${x}`)
    return api.get(`/v1/setting/dynamic-texts?${query.join('&')}`)
  },
  getImageS3: (s3KeyList: string[]) => {
    const query = s3KeyList.map((x) => `streamId=${x}`)
    return api.get(`/v1/download/url?${query.join('&')}`)
  },
  uploadMultiFile: (files: any) =>
    api.post(`/v1/uploader/temporary`, {}, files, {
      headers: { 'content-type': 'multipart/form-data' },
    }),
  downloadUrl: (streamIds: string) => api.get(`/v1/download/url?${streamIds}`),
  getDistance: (portFrom: string, portTo: string) =>
    api.get(`/v1/setting/route/origin/${portFrom}/destination/${portTo}`),
  getFootNote: (serviceType: SERVICE_TYPE) => {
    return api.get(`/v1/setting/foot-note/service-type/${serviceType}`)
  },
  getDepoInfo: (cyId: string | number) => api.get(`v1/setting/depo/${cyId}`),
  getPopupsAreaBySectionType: (params: { area_id: string; section_type: string }) =>
    api.get(`${FTL_WEB_APP_API}/api/v3/popups/area_by_section_type`, params),
}

export default settingApi
